export function getUTF8TextBytes(text: string): number {
  // TextEncoder is only available on Browser
  if (global.TextEncoder) {
    return new TextEncoder().encode(text).byteLength;
  }

  // Buffer is only available on Node.js
  return Buffer.byteLength(text, 'utf8');
}
